import i18n from '../i18n'
export default {
  install: function (Vue) {
    const UNITS = [
      {
        id: 1,
        name: 'label.gram',
        unit: 'g'
      },
      {
        id: 2,
        name: 'label.ml',
        unit: 'ml'
      },
      {
        id: 3,
        name: 'label.tablespoon',
        unit: '杯'
      },
      {
        id: 4,
        name: 'label.teaspoon',
        unit: '杯'
      }
    ]
    Vue.prototype.$units = {
      getUnit (id) {
        let result = '';
        UNITS.forEach((val) => {
          if (id === val.id) {
            result = val.unit
            return
          }
        })
        return result
      },
      formatUnit(id, amount) {
        let result = '';
        UNITS.forEach((val) => {
          if (id === val.id) {
            if (id === 3 || id === 4) {
              result += i18n.t(val.name)
            }
            result += amount + val.unit
            return
          }
        })
        return result
      },
      getOptions () {
        const result = []
        UNITS.forEach((val) => {
          result.push({ id: val.id, label: i18n.t(val.name) })
        })
        return result
      }
    }
  }
}